import { DateTime } from "luxon";
import classNames from "classnames";

import './DatePicker.scss';

const WEEKDAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

export default function DatePicker({ year, month, from, to, onChange, earliestDate }) {
  const weekday = DateTime.local(year, month).weekday;

  const renderEmptySpots = () => {
    if (weekday === 7) {
      return;
    }
    
    const days = Array(weekday).fill('');
    return days.map((_, index) => <div key={index} />);
  }

  const onClickDate = day => {
    onChange(DateTime.local(year, month, day).toISODate());
  }

  const renderDays = () => {
    const earliest = DateTime.fromISO(earliestDate).startOf('day');
    const daysInMonth = DateTime.local(year, month).daysInMonth;
    const fromDate = DateTime.fromISO(from);
    const toDate = DateTime.fromISO(to);
    const todayDate = DateTime.now();
    
    const renderDay = day => {
      const date = DateTime.local(year, month, day);
      const disabled = date > DateTime.now() || date < earliest;

      const single = date.hasSame(fromDate, 'day') && (!to || date.hasSame(toDate, 'day'));
      const start = date.hasSame(fromDate, 'day') && !single;
      const end = date.hasSame(toDate, 'day') && !single;
      const middle = fromDate < date && date < toDate && !end;
      const today = todayDate.hasSame(date, 'day');
      const selected = single || start || end;

      return (
        <button key={day} disabled={disabled} className={classNames({ selected, single, start, middle, end, today })} onClick={() => onClickDate(day)}>{ day }</button>
      );
    }

    const days = [];

    for (let i = 0; i < daysInMonth; ++i) {
      days.push(i + 1);
    }

    return days.map(day => renderDay(day));
  }

  return (
    <div className='__date-picker'>
      <div className='month-picker'>
        { WEEKDAYS.map(day => <div key={day} className="weekday">{ day }</div>) }
        { renderEmptySpots() }
        { renderDays() }
      </div>
    </div>
  )
}
